export const AppIcons = [
  '2CShop',
  'Funpinpin',
  'Magento',
  'Meshop',
  'Opencart',
  'Shopexpress',
  'Shoplazza',
  'Shoplus',
  'Shoptop',
  'Ueeshop',
  'WordPress',
  '华为',
  '小渔夫',
  '紫鸟',
  // '万云汇',
  'Amazon',
  'All value',
  'Android',
  'IOS',
  'Shopify',
  'Shopline',
  'Shopbase',
  'Woocommerce',
  'Xshoppy',
  'Shopyy',
];
